export default __webpack_public_path__ + "static/media/PORSCHE.bddd0efe.png";